import { AutocompleteGenericEntity } from '@australiangreens/ag-internal-components';
import { TASK_CHOICE_MAPPING, TASK_KIND_MAPPING } from '@/types';

export const TASK_CHOICE_AUTOCOMPLETE_OPTIONS: AutocompleteGenericEntity[] = Object.entries(
  TASK_CHOICE_MAPPING
).map(([key, val]) => ({
  id: key,
  label: val,
}));

export const TASK_KIND_AUTOCOMPLETE_OPTIONS: AutocompleteGenericEntity[] = Object.entries(
  TASK_KIND_MAPPING
).map(([key, val]) => ({
  id: key,
  label: val,
}));
